import { IOnInit } from "angular";
import { RecordDataSource } from "../../../../records/grids";
import {
  GridSettingsService,
  IGridSettings,
  vsName as GridSettingsServiceName,
} from "../../../../records/grids/settings/gridSettingsService";
import { ColDef } from "../../../../records/grids/columns/colDef";
import { IQuery } from "../../../../records/server/query";
import {
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../../../../records/views/recordGridView";

import { vsObjectName as projectMachineName } from "./../../../shared/configs/projectMachines";
import { vsObjectName as machineName } from "./../../../../machines/sanmanuel/configs/machine";
import { Record } from "../../../../records/server/crud";
import { StateProvider, StateParams, StateService } from "@uirouter/angularjs";
export class ProjectDetailMachineComponentController implements IOnInit {
  static $inject = [RecordGridViewServiceName, GridSettingsServiceName, "$stateParams"];

  /* bindings */
  defaultQuery?: IQuery;
  /* bindings */

  gridDataSource?: RecordDataSource;
  gridSettings?: IGridSettings;
  columns?: ColDef[];
  defaultSort?: string;
  nameSingular?: string;
  namePlural?: string;

  constructor(
    private readonly recordGridViewService: RecordGridViewService,
    private readonly gridSettingsService: GridSettingsService,
    public $stateParams: StateParams
  ) {}

  $onInit() {
      
    const gridConfiguration = this.recordGridViewService.getGridConfiguration(
      projectMachineName
    )!;
    
    const machineConfiguration =
      this.recordGridViewService.getGridConfiguration(machineName)!;
     
    this.gridDataSource = gridConfiguration.gridDataSource;
    this.gridSettings = this.gridSettingsService.getGridSettings(
      Symbol("project.machines")
    );
    this.columns = machineConfiguration.columns;
    this.defaultSort = gridConfiguration.defaultSort;
    this.nameSingular = gridConfiguration.nameSingular;
    this.namePlural = gridConfiguration.namePlural;

    
  }
}
